import FilePreview from './FilePreview'

export * from './FilePreview'
export default FilePreview
